import { IRiskOption } from "src/core/constants/options";
import { CustomRiskLevel } from "src/core/constants/risk";
import { ListElementWithRisk } from "src/core/gql/graphql";
import { mapRiskCategory } from "src/core/mappers/risk-category.mapper";

export const mapActivitiesToRiskOptions = (activities: ListElementWithRisk[]): IRiskOption[] => {
  return activities.map((activity) => {
    const defaultRisk = activity.riskValues.find((risk) => risk.key === "default");
    const risk = defaultRisk ? mapRiskCategory(defaultRisk.riskCategory) : CustomRiskLevel.LOW;

    return {
      id: activity.id,
      value: activity.code,
      label: activity.name,
      risk,
    };
  });
};
